(function () {
  'use strict';

  var formSelector = '[data-footer-signup-form]';
  var dialogSelector = '[role="dialog"][aria-label="20% off your first order email signup"]';
  var providerEmailSelector = 'form[data-testid="klaviyo-form-Skrwmu"] input[type="email"]';
  var timeoutMs = 8000;

  function visible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function start(form) {
    var field = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('.FooterSignup__Status');
    if (!field || !button || !status) return;

    var observer = null;
    var timer = null;
    var busy = false;

    function finish(message) {
      if (observer) observer.disconnect();
      if (timer) window.clearTimeout(timer);
      observer = null;
      timer = null;
      busy = false;
      button.disabled = false;
      status.textContent = message || '';
    }

    function prefill(email) {
      var dialog = document.querySelector(dialogSelector);
      if (!visible(dialog)) return false;
      var providerField = dialog.querySelector(providerEmailSelector);
      if (!providerField) return false;

      var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
      setter.call(providerField, email);
      providerField.dispatchEvent(new Event('input', { bubbles: true }));
      providerField.dispatchEvent(new Event('change', { bubbles: true }));
      providerField.focus();
      finish('');
      return true;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;
      var email = field.value.trim();
      if (!field.checkValidity() || !email) {
        field.reportValidity();
        return;
      }

      busy = true;
      button.disabled = true;
      status.textContent = 'Opening sign-up form…';

      observer = new MutationObserver(function () { prefill(email); });
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden'],
        childList: true,
        subtree: true
      });
      timer = window.setTimeout(function () {
        finish('The sign-up form did not open. Please try again.');
      }, timeoutMs);

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'Skrwmu']);
      if (typeof window.queueKlaviyoWidgets === 'function') window.queueKlaviyoWidgets();
      prefill(email);
    });
  }

  function init() {
    document.querySelectorAll(formSelector).forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
